// Will always be loaded
import { initAlpine, registerComponent, registerStore } from '@core/alpine-js';
import wishlistCounter from '../components/header/wishlist-counter';
import wishlistStatus from '../components/carousel/wishlist-status';
import compareStatus from '../components/compare/compare-status';
import customer from '../components/customer/customer';
import modalAddToCartProductSlider from '../components/product/modalAddToCartProductSlider';
import body from '../components/common/body';
import mageCacheStorage from '../stores/common/mage-cache-storage';
import mq from '../stores/common/mq';
import '../globals';
import productInfo from '../components/product/product-info';

registerComponent('customer', customer);
registerComponent('productInfo', productInfo);
registerComponent('wishlistCounter', wishlistCounter);
registerComponent('wishlistStatus', wishlistStatus);
registerComponent('compareStatus', compareStatus);
registerComponent('modalAddToCartProductSlider', modalAddToCartProductSlider);
registerComponent('body', body);
registerStore('mageCacheStorage', mageCacheStorage);
registerStore('mq', mq);

initAlpine();
